var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideMobileArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 71,
    viewBox: "0 0 44 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7092_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8664 63.7533L4.91244 35.8272C4.58064 35.4947 4.34617 35.1346 4.20903 34.7467C4.06968 34.3588 4 33.9433 4 33.5C4 33.0567 4.06968 32.6412 4.20903 32.2533C4.34617 31.8654 4.58064 31.5053 4.91244 31.1728L32.8664 3.16359C33.6406 2.38786 34.6083 2 35.7696 2C36.9309 2 37.9263 2.41557 38.7558 3.2467C39.5853 4.07784 40 5.04749 40 6.15567C40 7.26385 39.5853 8.23351 38.7558 9.06464L14.3687 33.5L38.7558 57.9354C39.53 58.7111 39.917 59.6663 39.917 60.8011C39.917 61.9381 39.5023 62.9222 38.6728 63.7533C37.8433 64.5844 36.8756 65 35.7696 65C34.6636 65 33.6959 64.5844 32.8664 63.7533Z",
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7092_1439",
    x: 0,
    y: 0,
    width: 44,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7092_1439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7092_1439",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMobileArrow);
export default __webpack_public_path__ + "static/media/sideMobileArrow.4edfcda01155d3d2c5bfb6dd6cb11e6e.svg";
export { ForwardRef as ReactComponent };